/* Élan – product page: variant pickers wired to Shopify variants, gallery + zoom + lightbox,
   engraving, quantity, AJAX add to bag, delivery timeline with automatic free-shipping line. */
(function () {
  'use strict';
  var E = window.Elan || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return E.formatMoney(c); };

  function addBusinessDays(days) {
    var d = new Date(), add = Number(days) || 0;
    while (add > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) add--; }
    return d;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString(E.locale === 'en' ? 'en-MY' : E.locale, { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }

  function fmtShort(d) {
    try { return d.toLocaleDateString(E.locale === 'en' ? 'en-GB' : E.locale, { month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var section = root.closest('.shopify-section') || document;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = $('form.pform', root);
    var idInput = $('[data-variant-id]', root);
    var qtyInput = $('[data-qty-input]', root);
    var addBtn = $('[data-add]', root);
    var errEl = $('[data-error]', root);
    var optEls = $$('[data-opt]', root);
    var engToggle = $('[data-engrave-toggle]', root), engInput = $('[data-engrave-input]', root), engBox = $('[data-engrave-box]', root);
    var sticky = $('[data-sticky]', section);
    var qty = 1;

    /* ---------- selection state ---------- */
    var nOpts = data.options.length;
    var selected = [];
    for (var i = 0; i < nOpts; i++) selected.push(null);
    optEls.forEach(function (el) {
      var on = $('.on', el);
      selected[+el.dataset.opt] = on ? on.dataset.value : null;
    });
    // options rendered without pickers (none) fall back to the current variant
    var initial = data.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || data.variants[0];
    for (var j = 0; j < nOpts; j++) {
      if (selected[j] === null && !optEls.some(function (el) { return +el.dataset.opt === j && el.hasAttribute('data-required'); })) selected[j] = initial.options[j];
    }

    function matchVariant(sel) {
      return data.variants.find(function (v) { return v.options.every(function (o, k) { return sel[k] === null || sel[k] === o; }); });
    }
    function exactVariant() {
      if (selected.some(function (s) { return s === null; })) return null;
      return data.variants.find(function (v) { return v.options.every(function (o, k) { return selected[k] === o; }); }) || null;
    }
    function current() { return exactVariant() || matchVariant(selected) || initial; }

    /* ---------- render ---------- */
    function paintOptions() {
      optEls.forEach(function (el) {
        var k = +el.dataset.opt;
        $$('[data-value]', el).forEach(function (b) {
          var on = selected[k] === b.dataset.value;
          b.classList.toggle('on', on); b.setAttribute('aria-checked', on);
          // availability given the other selections
          var test = selected.slice(); test[k] = b.dataset.value;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, x) { return test[x] === null || test[x] === o; });
          });
          b.classList.toggle('na', !ok);
        });
        var lab = $('[data-opt-label]', el); if (lab) lab.textContent = selected[k] || '';
      });
      // chips + spec cells
      $$('[data-chip]', root).forEach(function (chip) {
        var k = +chip.dataset.chip, el = optEls.find(function (o) { return +o.dataset.opt === k; });
        var b = el && $('[data-value].on', el);
        if (!b) return;
        chip.querySelector('em').textContent = b.dataset.value;
        chip.querySelector('i').style.background = b.dataset.chipBg;
      });
      $$('[data-spec-opt]', section).forEach(function (td) { var k = +td.dataset.specOpt; if (selected[k]) td.textContent = selected[k]; });
    }

    function update(pushUrl) {
      var exact = exactVariant(), v = current();
      var price = v ? v.price : 0;
      $('[data-price]', root).textContent = money(price);
      var cmp = $('[data-compare]', root);
      if (cmp) { if (v && v.compare > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare); } else cmp.hidden = true; }
      var missing = selected.indexOf(null) > -1;
      if (!missing && !exact) {
        addBtn.disabled = true; addBtn.textContent = E.strings.unavailable;
      } else if (exact && !exact.available) {
        addBtn.disabled = true; addBtn.textContent = E.strings.soldOut;
      } else {
        addBtn.disabled = false; addBtn.textContent = E.strings.addToBag + ' · ' + money(price * qty);
      }
      if (exact) idInput.value = exact.id;
      var stock = $('[data-stock]', root);
      if (stock) {
        var out = exact ? !exact.available : !(v && v.available);
        stock.classList.toggle('out', out); stock.textContent = out ? stock.dataset.out : stock.dataset.in;
      }
      var sku = $('[data-sku]', section), skuRow = $('[data-sku-row]', section);
      if (sku && v) { sku.textContent = v.sku || ''; skuRow.hidden = !v.sku; }
      var sp = $('[data-sticky-price]', section); if (sp) sp.textContent = money(price);
      if (exact && pushUrl && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', exact.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v && v.media && pushUrl) gallery.showMedia(v.media);
      shipNote();
    }

    optEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]'); if (!b) return;
        var k = +el.dataset.opt; selected[k] = b.dataset.value;
        el.classList.remove('err'); errEl.textContent = '';
        // if the exact combo doesn't exist, snap other options to the closest available variant
        if (!exactVariant() && selected.indexOf(null) === -1) {
          var alt = data.variants.find(function (v) { return v.available && v.options[k] === selected[k]; }) ||
                    data.variants.find(function (v) { return v.options[k] === selected[k]; });
          if (alt) selected = selected.map(function (s, x) { return x === k ? s : (optEls.some(function (o) { return +o.dataset.opt === x && o.hasAttribute('data-required'); }) && s === null ? null : alt.options[x]); });
        }
        paintOptions(); update(true);
      });
    });

    /* ---------- quantity ---------- */
    $$('[data-q]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(20, qty + Number(b.dataset.q)));
        qtyInput.value = qty; $('[data-qty-view]', root).textContent = qty; update(false);
      });
    });

    /* ---------- engraving ---------- */
    if (engToggle) {
      engToggle.addEventListener('change', function () {
        engBox.hidden = !engToggle.checked; engInput.disabled = !engToggle.checked;
        if (engToggle.checked) engInput.focus();
        delivery();
      });
      engInput.addEventListener('input', function () {
        $('[data-engrave-count]', root).textContent = engInput.value.length + '/' + engInput.maxLength;
        $('[data-engrave-preview]', root).textContent = engInput.value;
        delivery();
      });
    }

    /* ---------- delivery timeline ---------- */
    var S = E.shipping || {};
    function delivery() {
      var box = $('[data-ship]', section);
      var extra = (box ? Number(box.dataset.extraDays) || 0 : 0) + (engToggle && engToggle.checked && engInput.value.trim() ? Number(S.engravingDays || 0) : 0);
      var t = $('[data-eta-today]', section), s = $('[data-eta-ship]', section), a = $('[data-eta-arrive]', section);
      if (t) t.textContent = fmtDate(new Date());
      if (s) s.textContent = (E.strings.etaBy || 'by') + ' ' + fmtDate(addBusinessDays(Number(S.shipDays) + extra));
      if (a) {
        var lo = Number(S.arriveDays) + extra, hi = Math.max(Number(S.arriveDaysMax) || 0, Number(S.arriveDays)) + extra;
        a.textContent = hi > lo ? fmtShort(addBusinessDays(lo)) + ' – ' + fmtShort(addBusinessDays(hi)) : fmtDate(addBusinessDays(lo));
      }
    }
    function shipNote() {
      var note = $('[data-ship-note]', section);
      if (!note || !S.threshold) return;
      var v = current(); var unit = v ? v.price : 0;
      var inBag = E.cart ? E.cart.total_price : 0;
      var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      var thr = Math.round(S.threshold * rate), feeC = Math.round(S.fee * rate);
      var tot = inBag + unit * qty, left = thr - tot;
      var fee = S.feeLabel || money(feeC);
      var html;
      if (inBag >= thr) html = E.strings.bagFree;
      else if (left <= 0) html = inBag ? E.strings.freeWhenAdded : E.strings.freeOrder;
      else {
        html = (inBag ? E.strings.addMoreBag.replace('[bag]', E.escape(money(inBag))) : E.strings.addMore).replace('[left]', E.escape(money(left)));
        if (S.fee || S.feeLabel) html += ' · ' + E.escape(E.strings.otherwise.replace('[fee]', fee));
      }
      note.innerHTML = html;
    }
    document.addEventListener('elan:cart', shipNote);

    /* ---------- gallery ---------- */
    var gallery = (function () {
      var stage = $('[data-stage]', root), slides = $$('[data-slide]', root), thumbs = $$('[data-thumb]', root), dots = $$('[data-gdots] i', root);
      var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('on'); }));
      var hoverOK = window.matchMedia('(hover:hover)').matches, zoomed = false;
      var hint = $('[data-hint]', root); if (hint && !hoverOK) hint.textContent = hint.dataset.touch;
      function show(n) {
        if (!slides.length) return;
        idx = (n + slides.length) % slides.length; unzoom();
        slides.forEach(function (s, i) { s.classList.toggle('on', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('on', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
        $$('video', root).forEach(function (vd) { if (!vd.closest('.slide.on')) vd.pause(); });
        if (lb.open) lb.draw();
      }
      function img() { var s = slides[idx]; return s && s.dataset.type === 'image' ? s.querySelector('img') : null; }
      function zoomAt(x, y) {
        var im = img(); if (!im) return;
        var r = stage.getBoundingClientRect();
        im.style.transformOrigin = ((x - r.left) / r.width * 100).toFixed(1) + '% ' + ((y - r.top) / r.height * 100).toFixed(1) + '%';
        im.style.transform = 'scale(2.4)';
      }
      function unzoom() { var im = img(); if (im) im.style.transform = ''; stage && stage.classList.remove('zooming'); zoomed = false; }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.thumb); }); });
      if (stage) {
        $$('[data-gnav]', stage).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(idx + Number(b.dataset.gnav)); }); });
        var ex = $('[data-expand]', stage); ex && ex.addEventListener('click', function (e) { e.stopPropagation(); lb.show(); });
        if (hoverOK) {
          stage.addEventListener('mousemove', function (e) { if (e.target.closest('button') || !img()) return unzoom(); stage.classList.add('zooming'); zoomAt(e.clientX, e.clientY); });
          stage.addEventListener('mouseleave', unzoom);
          stage.addEventListener('click', function (e) { if (!e.target.closest('button') && img()) lb.show(); });
        } else {
          var sx = 0, sy = 0;
          stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
          });
          stage.addEventListener('click', function (e) { if (e.target.closest('button') || !img()) return; if (zoomed) unzoom(); else { zoomed = true; zoomAt(e.clientX, e.clientY); } });
        }
      }
      /* lightbox */
      var lb = {
        open: false, el: $('#lightbox'),
        show: function () { if (!lb.el || !slides.length) return; lb.open = true; lb.el.classList.add('show'); document.documentElement.style.overflow = 'hidden'; lb.draw(); },
        hide: function () { if (!lb.el) return; lb.open = false; lb.el.classList.remove('show'); lb.el.innerHTML = ''; document.documentElement.style.overflow = ''; },
        draw: function () {
          var s = slides[idx], src = s.dataset.full || (s.querySelector('img') && s.querySelector('img').currentSrc) || '';
          var th = thumbs.map(function (t, i) { return '<button type="button" class="thumb' + (i === idx ? ' on' : '') + '" data-lbv="' + i + '">' + t.innerHTML + '</button>'; }).join('');
          lb.el.innerHTML = '<div class="lbbar"><span><b style="font-weight:500">' + E.escape(data.title || document.title.split(' – ')[0]) + '</b> <span class="muted">· ' + (idx + 1) + '/' + slides.length + '</span></span><button type="button" class="hbtn" data-lbclose aria-label="Close"><svg class="ico" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
            '<div class="lbstage">' + (src ? '<img src="' + src + '" alt="' + E.escape(s.dataset.alt || '') + '">' : s.innerHTML) +
            (slides.length > 1 ? '<button type="button" class="navarrow l" data-lb="-1" aria-label="Previous"><svg class="ico" viewBox="0 0 24 24"><path d="m15 5-7 7 7 7"/></svg></button><button type="button" class="navarrow r" data-lb="1" aria-label="Next"><svg class="ico" viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg></button>' : '') +
            '</div>' + (slides.length > 1 ? '<div class="lbthumbs">' + th + '</div>' : '');
          var c = lb.el.querySelector('[data-lbclose]'); c && c.focus();
        }
      };
      if (lb.el) {
        lb.el.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          if (b.hasAttribute('data-lbclose')) return lb.hide();
          if (b.dataset.lb) show(idx + Number(b.dataset.lb));
          if (b.dataset.lbv) show(Number(b.dataset.lbv));
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lb.open) return;
        if (e.key === 'Escape') lb.hide();
        if (e.key === 'ArrowRight') show(idx + 1);
        if (e.key === 'ArrowLeft') show(idx - 1);
      });
      return {
        showMedia: function (mediaId) {
          var n = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
          if (n > -1) show(n);
        }
      };
    })();

    /* ---------- add to bag ---------- */
    function requireChoice() {
      var miss = optEls.find(function (el) { return selected[+el.dataset.opt] === null; });
      if (!miss) return false;
      var name = (miss.querySelector('.lab b') || {}).textContent || '';
      errEl.textContent = E.strings.chooseOption.replace('[option]', name.replace(/\s*\(US\)\s*$/, '').toLowerCase());
      miss.classList.add('err'); miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { miss.classList.remove('err'); }, 1600);
      return true;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (requireChoice()) return;
      var exact = exactVariant(); if (!exact || !exact.available) return;
      if (engInput && (!engToggle.checked || !engInput.value.trim())) engInput.disabled = true;
      var fd = new FormData(form);
      fd.set('id', exact.id); fd.set('quantity', qty);
      if ($('#drawer')) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
      addBtn.classList.add('loading'); errEl.textContent = '';
      fetch(E.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { errEl.textContent = res.j.description || res.j.message || E.strings.error; return; }
          if (res.j.sections && res.j.sections['cart-drawer']) E.renderDrawer(res.j.sections['cart-drawer']);
          return E.fetchCart().then(function () {
            if (E.cartType === 'drawer' && $('#drawer')) E.openDrawer(); else E.toast(E.strings.added);
          });
        })
        .catch(function () { errEl.textContent = E.strings.error; })
        .then(function () {
          addBtn.classList.remove('loading');
          if (engInput) engInput.disabled = !engToggle.checked;
        });
    });

    /* ---------- sticky add bar ---------- */
    if (sticky) {
      var sAdd = $('[data-sticky-add]', sticky);
      sAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
      var watch = function () {
        var r = addBtn.getBoundingClientRect(), show = r.bottom < 0;
        sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', !show);
        sAdd.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', watch, { passive: true }); watch();
    }

    paintOptions(); update(false); delivery();
    E.fetchCart().catch(function () {});
    // first paint: avoid "on" for held-back size; show base price of first matching variant
  }

  function boot() { $$('[data-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
